import { useNavigate, useParams } from 'react-router';
import { ElevatedButton } from '@producer/ui-kit';

import { CrossCircledFilledIcon } from '../../../components/icons/cross-circled-filled.icon';
import { useCurrentMember } from '../../../hooks/use-current-member';

import styles from './space-locked.placeholder.module.scss';
export const SpaceLockedPlaceholder = () => {
  const { spaceId } = useParams() as { spaceId: string };
  const navigate = useNavigate();

  const member = useCurrentMember();
  const isAdmin = member?.role === 'admin' || member?.role === 'owner';

  const handleClick = () => {
    navigate(`/space/${spaceId}/settings/billings`);
  };

  return (
    <div className={styles['container']}>
      <div className={styles['icon']}>
        <CrossCircledFilledIcon />
      </div>

      <h1>Your creative space is locked, but your data is safe</h1>

      {isAdmin ? (
        <>
          <p>
            Your creative space has been temporarily locked because your subscription is still
            overdue. Don’t worry—none of your data has been deleted. You can unlock your creative
            space and regain full access by renewing your subscription at any time.
          </p>

          <p>If you need assistance, we’re here to help!</p>
        </>
      ) : (
        <p>
          Your creative space has been temporarily locked because your subscription is overdue.
          Don’t worry—none of your data has been deleted. To regain access, please contact your
          creative space admin to update the subscription and unlock your account.
        </p>
      )}

      {isAdmin && (
        <div className={styles['actions']}>
          <ElevatedButton text="Unlock now" onClick={handleClick} />
          <a className={styles['link']} href={'mailto:support@the-producer.io'}>
            Contact support
          </a>
        </div>
      )}
    </div>
  );
};
